import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { callApi, HTTPMethod } from "../../../services/HttpService/HttpService";
import { OrderFeedbackApi } from "../../../constants/ApiConstants";
import OrderFeedback from "./order-feedback";
import OrderFeedbackV2 from "./order-feedback-v2";
import NoData from "../../../components/noData/noData";
import loader from "../../../assets/loader.gif";

const OrderFeedbackWrapper = () => {
    const [surveyVersion, setSurveyVersion] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchSurveyVersion = async () => {
            try {
                const queryParams = new URLSearchParams(location.search);
                const feedbackId =
                    queryParams.get("orderFeedbackId") ||
                    queryParams.get("Order-feedback-id");

                let response;

                if (feedbackId) {
                    const questionsUrl =
                        OrderFeedbackApi.orderFeedbackPageQuestions.replace(
                            "{order_feedback_id}",
                            feedbackId
                        );

                    response = await callApi(
                        HTTPMethod.Get,
                        questionsUrl,
                        null,
                        "event-api-call",
                        1,
                        true
                    );
                }

                if (response?.status_code === 200 && response?.data) {
                    if (typeof response.data.surveyVersion !== "undefined") {
                        setSurveyVersion(response.data.surveyVersion);
                    } else if (typeof response.data.survey_version !== "undefined") {
                        setSurveyVersion(response.data.survey_version);
                    } else {
                        setSurveyVersion(1);
                    }
                  } else {
                    setSurveyVersion(location.pathname.includes('order-feedback-v2') ? 2 : null);
                  }
            } catch (error) {
                setSurveyVersion(null);
            } finally {
                setLoading(false);
            }
        };

        fetchSurveyVersion();
    }, [location]);

    if (loading) {
        return (
            <div className="marginVerticalThirty">
                <NoData message={<img alt="Loading..." src={loader} />} />
            </div>
        );
    }

    if (surveyVersion === null) {
        return (
            <NoData message="Unable to load survey. Please check your link or try again later." />
        );
    }

    return surveyVersion === 2 ? <OrderFeedbackV2 /> : <OrderFeedback />;
};

export default OrderFeedbackWrapper;
